import './polyfills';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { TonConnectUIProvider } from '@tonconnect/ui-react';

import { APP_URL, BOT_USERNAME } from './config';
import { App } from './App';
import { bootTelegram } from './telegram/webapp';
import './styles.css';

bootTelegram();

const origin = APP_URL || window.location.origin;
const manifestUrl = `${origin.replace(/\/$/, '')}/tonconnect-manifest.json`;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <TonConnectUIProvider
      manifestUrl={manifestUrl}
      actionsConfiguration={{
        twaReturnUrl: `https://t.me/${BOT_USERNAME}/app`,
      }}
    >
      <App />
    </TonConnectUIProvider>
  </StrictMode>,
);
